import { cn } from "@/lib/utils";
import { StatusBadge } from "./StatusBadge";
import { Container, Waypoints, Cloud, Github, KeyRound, Mail } from "lucide-react";

const ICONS = {
  docker: Container,
  npm: Waypoints,
  cloudflare: Cloud,
  github: Github,
  vault: KeyRound,
  email: Mail,
};

// Card de integração externa (ícone, nome, info secundária, status). Nunca corta nome/versão.
export const IntegrationCard = ({ integration, onOpen }) => {
  const Icon = ICONS[integration.icon] || Container;
  const secondary = [integration.version !== "—" ? integration.version : null, integration.meta]
    .filter(Boolean)
    .join(" · ");
  return (
    <button
      onClick={onOpen}
      data-testid={`integration-card-${integration.id}`}
      className="group flex w-full items-center gap-3 rounded-xl border border-line bg-surface p-3 text-left transition-colors hover:bg-surface-hover"
    >
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-line bg-white/[0.03] text-muted-foreground">
        <Icon className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-foreground">{integration.name}</p>
        <p className="truncate text-xs text-muted-foreground">{secondary}</p>
      </div>
      <StatusBadge status={integration.status} size="sm" className="shrink-0" />
    </button>
  );
};
